import { SVGProps } from 'react';

const MasterCardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="124"
      height="24"
      viewBox="0 0 124 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.4502 2.56667H56.9502V21.4333H67.4502V2.56667Z"
        fill="#FF5F00"
      />
      <path
        d="M57.6165 12.0001C57.6165 8.16673 59.4165 4.76673 62.1832 2.56673C60.1499 0.966728 57.5832 6.10352e-05 54.7832 6.10352e-05C48.1499 6.10352e-05 42.7832 5.36673 42.7832 12.0001C42.7832 18.6334 48.1499 24.0001 54.7832 24.0001C57.5832 24.0001 60.1499 23.0334 62.1832 21.4334C59.4165 19.2667 57.6165 15.8334 57.6165 12.0001Z"
        fill="#EB001B"
      />
      <path
        d="M81.6168 12C81.6168 18.6333 76.2501 24 69.6168 24C66.8168 24 64.2501 23.0333 62.2168 21.4333C65.0168 19.2333 66.7835 15.8333 66.7835 12C66.7835 8.16667 64.9835 4.76667 62.2168 2.56667C64.2501 0.966667 66.8168 0 69.6168 0C76.2501 0 81.6168 5.4 81.6168 12Z"
        fill="#F79E1B"
      />
    </svg>
  );
};

export default MasterCardIcon;
